import { useEffect, useState } from 'react';

import { Button, Dialog } from '@revelio/ui';

import { useToast } from '../../../hooks/useToast';
import type { ReportParameterConfig } from '../../PageConfigProvider/page-reducer';
import { ParameterEditor } from './ParameterEditor';
import { determinePrimaryParameter, parametersAreValid } from './parameters';

export function ReportParametersModal({
  isOpen,
  onClose,
  defaultValue,
  onSave,
}: {
  isOpen: boolean;
  onClose: () => void;
  defaultValue?: ReportParameterConfig[];
  onSave: (params: ReportParameterConfig[] | undefined) => void;
}) {
  const toast = useToast();
  const [parameters, setParameters] = useState<ReportParameterConfig[]>(
    defaultValue ?? []
  );

  // biome-ignore lint/correctness/useExhaustiveDependencies: migrated from develop
  useEffect(() => {
    setParameters(defaultValue ?? []);
  }, [defaultValue, isOpen]);

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      title="Configure Report Parameters"
      size="2xl"
      footer={
        <>
          <Button size="sm" color="secondary" variant="ghost" onClick={onClose}>
            Close
          </Button>
          <Button
            size="sm"
            color="primary"
            onClick={() => {
              const parametersWithPrimary =
                determinePrimaryParameter(parameters);
              const validation = parametersAreValid(parametersWithPrimary);
              if (validation.isValid) {
                onSave(parametersWithPrimary);
                onClose();
              } else {
                toast({
                  title: 'Invalid parameter configuration',
                  description: validation.reason,
                  status: 'error',
                });
              }
            }}
          >
            Save
          </Button>
        </>
      }
    >
      <ParameterEditor parameters={parameters} onChange={setParameters} />
    </Dialog>
  );
}
